import { render, staticRenderFns } from "./SectionPositions.vue?vue&type=template&id=027cd9b0&scoped=true&"
import script from "./SectionPositions.vue?vue&type=script&lang=js&"
export * from "./SectionPositions.vue?vue&type=script&lang=js&"
import style0 from "./SectionPositions.vue?vue&type=style&index=0&id=027cd9b0&lang=scss&scoped=true&"
import style1 from "./SectionPositions.vue?vue&type=style&index=1&id=027cd9b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027cd9b0",
  null
  
)

export default component.exports